import { doAxiosGet } from '../services/http';
export const fetchNetworkStatus = url => doAxiosGet(url);